import React from 'react';
import Icon from '@mui/material/Icon';
import PropTypes from 'prop-types';

export default function MacIcon(props) {
    return (
        <Icon>{props.icon}</Icon>
    );
}

MacIcon.propTypes = {
    icon: PropTypes.string
}
